import { render } from "./SobreNosView.vue?vue&type=template&id=5ed2a0b4"
import script from "./SobreNosView.vue?vue&type=script&lang=js"
export * from "./SobreNosView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__